import React from 'react';
import { Field } from 'redux-form';
import renderInput from './form-input';
import { Form } from 'semantic-ui-react';
import { maxLength, validateExp } from '../../utils/validation';

const renderPhone = ({ areaCode, firstThreeDigits, lastFourDigits, label, errorMessage, invalidErrorMessage, customClass, onClick, required }) => {
  const showError = (areaCode.meta.touched || firstThreeDigits.meta.touched || lastFourDigits.meta.touched) &&
    (areaCode.meta.error || firstThreeDigits.meta.error || lastFourDigits.meta.error);
  return (
    <Form.Group className={ `multiple-inputs ${customClass || ''} ${showError ? 'error' : ''}` }>
      <label className={ required ? 'required' : '' }>{label}</label>
      <div className="phone">
        <Field
          type="tel"
          name="areaCode"
          customClass="area-code"
          placeholder="(123)"
          min="0"
          component={ renderInput }
          normalize={ (value, previousValue) => {
            value = maxLength(3)(value, previousValue);
            if (!validateExp({ type: 'justNumbers', value })) {
              return previousValue;
            }
            return value;
          } }
          onClick={ onClick }
        />
        <Field
          type="tel"
          name="firstThreeDigits"
          customClass="first-three-digits"
          placeholder="456"
          min="0"
          component={ renderInput }
          normalize={ (value, previousValue) => {
            value = maxLength(3)(value, previousValue);
            if (!validateExp({ type: 'justNumbers', value })) {
              return previousValue;
            }
            return value;
          } }
          onClick={ onClick }
        />
        <Field
          type="tel"
          name="lastFourDigits"
          customClass="last-four-digits"
          placeholder="7890"
          min="0"
          component={ renderInput }
          normalize={ (value, previousValue) => {
            value = maxLength(4)(value, previousValue);
            if (!validateExp({ type: 'justNumbers', value })) {
              return previousValue;
            }
            return value;
          } }
          onClick={ onClick }
        />
      </div>
      {showError && (
        <label className="ui label basic error-message">
          {(areaCode.meta.error && areaCode.meta.error.invalid) ||
          (firstThreeDigits.meta.error &&
            firstThreeDigits.meta.error.invalid) ||
          (lastFourDigits.meta.error && lastFourDigits.meta.error.invalid)
            ? invalidErrorMessage
            : !areaCode.input.value &&
              !firstThreeDigits.input.value &&
              !lastFourDigits.input.value
              ? errorMessage
              : invalidErrorMessage}
        </label>
      )}
    </Form.Group>);
};

export default renderPhone;
